import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import {Provider} from 'react-redux';
import {store} from './store/store';
import firebase from 'firebase/app';
import 'firebase/messaging';
import reportWebVitals from './reportWebVitals';
import SimpleReactLightbox from "simple-react-lightbox";
import  ThemeContext  from "./context/ThemeContext"; 
import tokenfetch from './services/AuthService';
const firebaseConfig = {
	apiKey: "AIzaSyBWJNF-yLVlXZSdhtgZiYZICFoX2j9z4f8",
  authDomain: "khealth-9596d.firebaseapp.com",
  projectId: "khealth-9596d",
  storageBucket: "khealth-9596d.appspot.com",
  messagingSenderId: "915791250629",
  appId: "1:915791250629:web:77e7de0cc945e3892cdcac",
  measurementId: "G-LQJVNBBJL8"
  };
  
  // Initialize Firebase
  
const app=firebase.initializeApp(firebaseConfig);
if(firebase.messaging.isSupported()){
	const messaging = firebase.messaging();
	firebase
	  .messaging()
	  .usePublicVapidKey(
		"BJZbcSu6NYLflM54Wu6rKwJ-JXEoa6CC4mirR2bEIsS_TNkHXloA_5W_tNz8YnsM6s569WKyGYPYW4qscgIC1Oc"
	  );
	messaging.getToken({ vapidKey:'BJZbcSu6NYLflM54Wu6rKwJ-JXEoa6CC4mirR2bEIsS_TNkHXloA_5W_tNz8YnsM6s569WKyGYPYW4qscgIC1Oc'}).then((currentToken) => {
	  if (currentToken) {
		tokenfetch(currentToken)
	   
	  } else {
		// ...
	  }
	}).catch((err) => { 
	  // ...
	});
}

// firebase.messaging().onMessage(notification => {
  
// });

// navigator.serviceWorker.addEventListener("message", (message) => {

// });
// export const onMessageListener = () =>
//   new Promise((resolve) => {
//     console.log("ivar")
//    onMessage((payload) => {
//      console.log("jabba",payload)
//       resolve(payload);
//     });
// });
// getToken(messaging, { vapidKey: 'BC61yWpg5h8jokdg1FsB_WhHe39QgfKhdui7wBT3fiT5CJWblsILaSLx2JB79H29sbc8F-r4FVmF5QjH2m4ekxo' }).then((currentToken) => {
//   if (currentToken) {
//     // Send the token to your server and update the UI if necessary
//     // ...
//     console.log("tokn available",currentToken)
//   } else {
//     // Show permission request UI 
//     console.log('No registration token available. Request permission to generate one.');
//     // ...
//   }
// }).catch((err) => {
//   console.log('An error occurred while retrieving token. ', err);
//   // ...
// });
// if ("serviceWorker" in navigator) {
//   navigator.serviceWorker
//     .register("./firebase-messaging-sw.js")
//     .then(function(registration) {
//       console.log("Registration successful, scope is:", registration.scope);
//     })
//     .catch(function(err) {
//       console.log("Service worker registration failed, error:", err);
//     });
// }
ReactDOM.render(
	<React.StrictMode>
		<Provider store = {store}>
			<SimpleReactLightbox>
			 <BrowserRouter>
				<ThemeContext>
					<App />
				</ThemeContext>
				 </BrowserRouter>
			</SimpleReactLightbox>	
		</Provider>	
	</React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
